import { useMemo } from 'react';
import { configureTableColumns } from 'utils/table-helpers';
import { useTerminalTableColumns, TerminalsColumns } from '../constants/table-settings';
import { FETCH_ALL_PARAMS } from 'constants/query';
import { useGetAccountsQuery } from 'features/account/services';
import { APP_ROLES } from 'constants/app-roles';
import useTable from 'hooks/useTable';

export const useController = () => {
    const { data: terminals } = useGetAccountsQuery({ ...FETCH_ALL_PARAMS, role_id: APP_ROLES.TERMINAL });

    const filterSelectOptions = useMemo(() => {
        if (!terminals) return;

        return {
            accountEmail: terminals.content.map((account) => {
                return {
                    value: account.id.toString(),
                    label: account.email,
                };
            }),
        };
    }, [terminals]);

    const { tableSettings } = useTable<TerminalsColumns>({
        columns: configureTableColumns(useTerminalTableColumns(), filterSelectOptions || {}),
        queryIdentifier: 'terminals',
    });

    return {
        tableSettings,
    };
};

export default useController;
